export default __webpack_public_path__ + "static/media/Live_Classes.34eea037.svg";